module.exports = __webpack_public_path__ + "static/media/14.d5f5cd52.jpg";